import { cn } from "@/lib/utils";

import { ScrollSpyLink } from "./scrollspy-link";
import type { SectionNode } from "./types";

type Props = {
  sections: SectionNode[];
  activeId: string | null;
  onNavigate?: (event: React.MouseEvent<HTMLAnchorElement>, id: string) => void;
  isSubTree?: boolean;
  className?: string;
};

export function NavTree({
  sections,
  activeId,
  onNavigate,
  isSubTree = false,
  className,
}: Props) {
  return (
    <nav className={className}>
      <ul
        className={cn(
          "flex flex-col",
          !isSubTree && "[&>li:last-child>a]:border-b-0",
        )}
      >
        {sections.map((section) => (
          <li key={`${section.type}: ${section.name}`}>
            {section.type === "list" ? (
              <>
                <ScrollSpyLink
                  section={section}
                  isActive={activeId === section.id}
                  onNavigate={onNavigate}
                />
                <NavTree
                  sections={section.links}
                  activeId={activeId}
                  onNavigate={onNavigate}
                  isSubTree={true}
                />
              </>
            ) : (
              <ScrollSpyLink
                section={section}
                isActive={activeId === section.id}
                onNavigate={onNavigate}
              />
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
}
